import { AppBar, Box, Button, ClickAwayListener, Container, CssBaseline, Grid, Grow, Link, makeStyles, MenuItem, MenuList, Paper, Popper, Tab, Tabs, TextField, Theme, Toolbar, Typography, useMediaQuery } from '@material-ui/core';
import { Email, Language, LocationOn, Phone, Send } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import '.././App.css';
import { useAppStyles } from '../App';
import { Dimosieuseis } from './DimosieuseisEn';
import { EnotitesEn } from './EnotitesEn';
import { ForeisEn } from './ForeisEn';
import { XronodiagrammaParadoteonEn } from './XronodiagrammaParadoteonEn';

type TabPanelProps = { index: number, value: number }

export const TabPanel: React.FC<TabPanelProps> = props => {
  return (
    props.index === props.value ? <Box p={3} component='div'>
      {props.children}
    </Box> : null
  )
}

export const AppEn = () => {
  const classes = useAppStyles()
  const isLargeDisplay = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
  const history = useHistory()

  const [activeTab, setActiveTab] = useState(0)
  const [open, setOpen] = React.useState(false)
  const [activeDescription, setActiveDescription] = useState(0)

  const EMPTY_MESSAGE = { email: '', name: '', message: '', phone: '' }
  const [message, setMessage] = useState(EMPTY_MESSAGE)

  const anchorRef = React.useRef<HTMLAnchorElement | null>(null)

  const handleToggle = (e: any) => {
    setOpen((prevOpen) => !prevOpen);
  }

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  }

  function handleListKeyDown(event: any) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef?.current?.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const tabs = <Tabs value={activeTab} onChange={(_, v) => v !== 7 && setActiveTab(v)} centered scrollButtons='on' variant="scrollable">
    <Tab value={7} color="inherit" className={classes.toolbarLink} wrapped={false} onClick={e => history.push('/')}
      label={<Typography>ΕΛΛΗΝΙΚΑ</Typography>}
    />
    <Tab value={0} color="inherit" className={classes.toolbarLink} wrapped={false} label="ABOUT THE PROJECT" />
    <Tab value={1} color="inherit" className={classes.toolbarLink} wrapped={false} label="PARTNERS" ref={anchorRef as any} onClick={handleToggle} />
    <Tab value={2} color="inherit" className={classes.toolbarLink} wrapped={false} label="WORK PACKAGES" />
    <Tab value={3} color="inherit" className={classes.toolbarLink} wrapped={false} label="DELIVERABLES" />
    <Tab value={4} color="inherit" className={classes.toolbarLink} wrapped={false} label="PUBLICATIONS/CONFERENCES" />
    <Tab value={5} color="inherit" className={classes.toolbarLink} wrapped={false} label="NEWS" />
    <Tab value={6} color="inherit" className={classes.toolbarLink} wrapped={false} label="CONTACT" />
  </Tabs>

  return (
    <div className="App">
      <CssBaseline />

      <AppBar position='sticky' className={classes.appBar}>
        <img src="/holea-final.png" alt="logo" className={classes.banner} />
        <Toolbar component="nav" variant='dense' className={classes.toolbar}>
          {isLargeDisplay ?
            <Grid container direction="column" alignItems="center" justify="center" style={{ width: '100%', }}>
              <Grid item>
                {tabs}
              </Grid>
            </Grid> : tabs}
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" className={classes.container}>

        <main className={classes.main}>

          <TabPanel value={activeTab} index={0}>
            <Typography variant='h5'>About the project</Typography>
            <p>
              <Typography align='justify'>
                Title of HOLEA Project:
                <i>
                  Application of modern analytical and chemometric techniques for the quality control- fraud of olive products
                </i>
              </Typography>
            </p>
            <Typography align='justify'>
              <p>
                The HOLEA research project was co-funded by the European Union (ERDF) and Greek National funds, through the Operational Program "Competitiveness, Entrepreneurship and Innovation" 2014–2020 (EPAnEK), under the call “RESEARCH–CREATE–INNOVATE” (project code: 03816).
              </p>
            </Typography>

            <Typography variant='h5'>Description</Typography>

            <Typography align='justify'>
              <p>
                Quality is widely recognized as one of the most strategies for the economic development of each productive sector. Olive oil and edible olives are commercial products with continuously increasing demand worldwide, due to their valuable nutrients. Constant consumer demand for the production of high nutritional value products encourages practices of fraud in manufactured products which in recent years have been expanded, due to a lack of adequate quality control systems. Consequently, the quality control of edible olives and olive oil as well as the traceability of their origin are the main keys to ensuring the quality of the above products. Τhe present research proposal aims firstly to the traceability of Greek olive varieties, in order to certify the origin of the final products and, secondly, to the development and application of modern analytical techniques in order to ensure the quality of edible olives (using an alkaline solution or treatment with brine) and the documentation of the health claim for oils that meet the criteria of the EFSA, with aim the protection of consumers from false or misleading labels in olive products and olive oil. At the same time, efforts will be made to develop certified methodologies to ensure the quality of PDO and PGI olive oil from attempts of fraud, through the traceability of Greek olive varieties and their geographical origin. For the successful realization of the project two companies, with a significant activity in the production, marketing and promotion of olive products will cooperate as well as five research institutions, with proven experience in the field, of olive oil which will operate as consultants and will carry out specific research tasks of the present proposal. The expected results of the proposal relate to the creation and installation of a reliable private quality assurance protocol aiming both at the quality control of olive products and in securing the consumer against fraud. Given that for the Greek economy the agri-food sector is or must be the crown of growth and productive reconstruction of our country, it is more than necessary for Greece to invest in the quality of its agricultural products.
                The funding of the HOLEA Research Project implementation is € 994,610.00, of which the public expenditure amounts to € 945,580.00.
              </p>
            </Typography>
          </TabPanel>

          <TabPanel value={activeTab} index={1}>
            <ForeisEn activeDescription={activeDescription} />
          </TabPanel>

          <TabPanel value={activeTab} index={2}>
            <EnotitesEn />
          </TabPanel>
          <TabPanel value={activeTab} index={3}>
            <XronodiagrammaParadoteonEn />
          </TabPanel>
          <TabPanel value={activeTab} index={4}>

          </TabPanel>
          <TabPanel value={activeTab} index={6}>
            <Grid container spacing={2}>

              <Grid item xs={12} sm={6}>
                <Typography variant='h5'>Contact</Typography>
                <p>
                  <Typography >
                    <br />
                    <br />
                    <br />
                Dr. Stathopoulos Panagiotis<br />
                Section of Pharmacognosy & Chemistry of Natural Products<br />
                Faculty of Pharmacy<br />
                NKUA<br />
                    <LocationOn className={classes.communication} />
                Panepistimiopolis of Zographou<br />
                15771, Athens<br />
                    <Phone className={classes.communication} /> Tel: 210 7274886<br />
                    <Email className={classes.communication} /> <Link href='mailto:stathopan@pharm.uoa.gr'>stathopan@pharm.uoa.gr</Link> <br />
                  </Typography>
                </p>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant='h5'>Send a message</Typography>
                <p>
                  <TextField value={message.name} onChange={e => setMessage({ ...message, name: e.target.value })} fullWidth label="Your name" />
                  <TextField value={message.email} onChange={e => setMessage({ ...message, email: e.target.value })} type='email' fullWidth label="Your email" />
                  <TextField value={message.phone} onChange={e => /^\d{0,10}$/.test(e.target.value) && setMessage({ ...message, phone: e.target.value })} fullWidth label="Your phone number" />
                  <TextField value={message.message} onChange={e => setMessage({ ...message, message: e.target.value })} fullWidth label="Message" multiline rows={5} />
                </p>
                <p>
                  <Button disabled={!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(message.email) || message.message.length <= 3 || message.name.length <= 3} variant='contained' color='primary' startIcon={<Send />}
                    onClick={() => {
                      const req = new XMLHttpRequest()
                      req.onload = () => {
                        //if (req.status === 204) {
                        setMessage(EMPTY_MESSAGE)
                        //}
                      }
                      req.open('POST', 'https://techyotic-prod-holea.azurewebsites.net/api/ContactFormApi?code=QmkM3xCff5orJtu7LYdrJ4r/0NAYAX39MVNbObcxVSBVrut6OAfDBw==')
                      req.send(JSON.stringify(message))
                    }}>
                    Send
                  </Button>
                </p>
              </Grid>

            </Grid>


          </TabPanel>
          <TabPanel value={activeTab} index={7}>

          </TabPanel>
        </main>
      </Container>

      <footer className={classes.footer}>
        <Container maxWidth="lg">
          <Typography variant="h6" align="center" gutterBottom>
            HOLEA
          </Typography>
          <Typography variant="body2" color="inherit" align="center">
            <Link color="inherit" href="https://holea.gr">
              holea
            {' © '}
            </Link>{' '}
            {new Date().getFullYear()}
            {'. Developed by techyotic.'}
          </Typography>
        </Container>
      </footer>

    </div>
  );
}

export default AppEn;
